import type { ReactNode } from 'react';

export const symbol_mobile_landscape: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M100-200q-24 0-42-18t-18-42v-438q0-24.75 17.63-42.38Q75.25-758 100-758h150q3-18 16.95-30 13.96-12 31.63-12H373q19 0 33 12t17 30h437q24.75 0 42.38 17.62Q920-722.75 920-698v438q0 24.75-17.62 42.37Q884.75-200 860-200H100Zm760-60v-438H100v438h760ZM100-698v438-438Zm131 240q9-9 9-21t-9-21q-9-9-21-9t-21 9q-9 9-9 21t9 21q9 9 21 9t21-9Z"
		/>
	</svg>
);
